function mapColorNameToCSSVariable(colorNames) {
    const regex = /_/g;
    return Object.keys(colorNames).reduce((acc, color) => {
        return Object.assign(Object.assign({}, acc), { [color]: `--${color.replace(regex, "-")}` });
    }, {});
}
/**
 * @deprecated use `ThemeColors` instead.
 * avoid using specific categorical color names like OldColorNames in your components.
 * it will be removed in the future.
 */
export var OldColorNames;
(function (OldColorNames) {
    OldColorNames["color_primary_android_app_bar"] = "color_primary_android_app_bar";
    OldColorNames["color_primary_p_5015"] = "color_primary_p_5015";
    OldColorNames["color_primary_p_60"] = "color_primary_p_60";
    OldColorNames["color_neutrals_n_600"] = "color_neutrals_n_600";
    OldColorNames["color_neutrals_on_app_bar"] = "color_neutrals_on_app_bar";
    OldColorNames["secondary_main"] = "secondary_main";
    OldColorNames["secondary_light"] = "secondary_light";
    OldColorNames["secondary_dark"] = "secondary_dark";
    OldColorNames["color_neutrals_snack_bar"] = "color_neutrals_snack_bar";
    OldColorNames["color_bubble_mask"] = "color_bubble_mask";
    OldColorNames["background_chat"] = "background_chat";
    OldColorNames["color_call_background"] = "color_call_background";
    OldColorNames["color_call_chips_background"] = "color_call_chips_background";
    OldColorNames["color_call_gride_background"] = "color_call_gride_background";
    OldColorNames["color_call_default_button"] = "color_call_default_button";
    OldColorNames["color_call_end_button"] = "color_call_end_button";
    OldColorNames["color_call_call_button"] = "color_call_call_button";
    OldColorNames["color_call_call_toast"] = "color_call_call_toast";
    OldColorNames["color_call_share_screen_button"] = "color_call_share_screen_button";
    OldColorNames["color_call_on_background"] = "color_call_on_background";
    OldColorNames["Skeleton_dark"] = "Skeleton_dark";
    OldColorNames["Skeleton_light"] = "Skeleton_light";
    OldColorNames["skeleton_color"] = "skeleton_color";
    OldColorNames["magazine_gradient_start"] = "magazine_gradient_start";
    OldColorNames["magazine_gradient_end"] = "magazine_gradient_end";
})(OldColorNames || (OldColorNames = {}));
const OldColors = mapColorNameToCSSVariable(OldColorNames);
export var PrimaryColorNames;
(function (PrimaryColorNames) {
    PrimaryColorNames["color_primary_p_40"] = "color_primary_p_40";
    PrimaryColorNames["color_primary_p_50"] = "color_primary_p_50";
})(PrimaryColorNames || (PrimaryColorNames = {}));
const PrimaryColors = mapColorNameToCSSVariable(PrimaryColorNames);
export var DarkNeutralsColorNames;
(function (DarkNeutralsColorNames) {
    DarkNeutralsColorNames["color_neutrals_n_100"] = "color_neutrals_n_100";
    DarkNeutralsColorNames["color_neutrals_n_200"] = "color_neutrals_n_200";
    DarkNeutralsColorNames["color_neutrals_n_300"] = "color_neutrals_n_300";
    DarkNeutralsColorNames["color_neutrals_n_400"] = "color_neutrals_n_400";
    DarkNeutralsColorNames["color_neutrals_n_500"] = "color_neutrals_n_500";
})(DarkNeutralsColorNames || (DarkNeutralsColorNames = {}));
const DarkNeutralsColors = mapColorNameToCSSVariable(DarkNeutralsColorNames);
export var LightNeutralsColorNames;
(function (LightNeutralsColorNames) {
    LightNeutralsColorNames["color_neutrals_n_00"] = "color_neutrals_n_00";
    LightNeutralsColorNames["color_neutrals_n_10"] = "color_neutrals_n_10";
    LightNeutralsColorNames["color_neutrals_n_20"] = "color_neutrals_n_20";
    LightNeutralsColorNames["color_neutrals_n_30"] = "color_neutrals_n_30";
    LightNeutralsColorNames["color_neutrals_n_40"] = "color_neutrals_n_40";
    LightNeutralsColorNames["color_neutrals_n_50"] = "color_neutrals_n_50";
    LightNeutralsColorNames["color_neutrals_surface"] = "color_neutrals_surface";
    LightNeutralsColorNames["color_neutrals_on_primary"] = "color_neutrals_on_primary";
    LightNeutralsColorNames["color_neutrals_mask"] = "color_neutrals_mask";
    LightNeutralsColorNames["color_neutrals_gold_bg"] = "color_neutrals_gold_bg";
    LightNeutralsColorNames["color_neutrals_n_400"] = "color_neutrals_n_400";
    LightNeutralsColorNames["color_bubble_background_icon"] = "color_bubble_background_icon";
    LightNeutralsColorNames["color_neutrals_service_message"] = "color_neutrals_service_message";
})(LightNeutralsColorNames || (LightNeutralsColorNames = {}));
const LightNeutralsColors = mapColorNameToCSSVariable(LightNeutralsColorNames);
export var AlternativeColorNames;
(function (AlternativeColorNames) {
    AlternativeColorNames["color_alternative_a_01"] = "color_alternative_a_01";
    AlternativeColorNames["color_alternative_a_02"] = "color_alternative_a_02";
    AlternativeColorNames["color_alternative_a_03"] = "color_alternative_a_03";
    AlternativeColorNames["color_alternative_a_04"] = "color_alternative_a_04";
    AlternativeColorNames["color_alternative_a_05"] = "color_alternative_a_05";
    AlternativeColorNames["color_alternative_a_06"] = "color_alternative_a_06";
    AlternativeColorNames["color_alternative_a_07"] = "color_alternative_a_07";
    AlternativeColorNames["color_alternative_a_08"] = "color_alternative_a_08";
    AlternativeColorNames["color_alternative_a_09"] = "color_alternative_a_09";
    AlternativeColorNames["color_alternative_a_10"] = "color_alternative_a_10";
    AlternativeColorNames["color_alternative_opacity_a_01"] = "color_alternative_opacity_a_01";
    AlternativeColorNames["color_alternative_opacity_a_02"] = "color_alternative_opacity_a_02";
    AlternativeColorNames["color_alternative_opacity_a_03"] = "color_alternative_opacity_a_03";
    AlternativeColorNames["color_alternative_opacity_a_04"] = "color_alternative_opacity_a_04";
    AlternativeColorNames["color_alternative_opacity_a_05"] = "color_alternative_opacity_a_05";
    AlternativeColorNames["color_alternative_opacity_a_06"] = "color_alternative_opacity_a_06";
    AlternativeColorNames["color_alternative_opacity_a_07"] = "color_alternative_opacity_a_07";
    AlternativeColorNames["color_alternative_opacity_a_08"] = "color_alternative_opacity_a_08";
    AlternativeColorNames["color_alternative_opacity_a_09"] = "color_alternative_opacity_a_09";
    AlternativeColorNames["color_alternative_opacity_a_10"] = "color_alternative_opacity_a_10";
})(AlternativeColorNames || (AlternativeColorNames = {}));
const AlternativeColors = mapColorNameToCSSVariable(AlternativeColorNames);
export var StateColorNames;
(function (StateColorNames) {
    StateColorNames["color_error"] = "color_error";
    StateColorNames["color_success"] = "color_success";
    StateColorNames["color_link"] = "color_link";
    StateColorNames["color_alert"] = "color_alert";
})(StateColorNames || (StateColorNames = {}));
const StateColors = mapColorNameToCSSVariable(StateColorNames);
export var BubbleColorNames;
(function (BubbleColorNames) {
    BubbleColorNames["color_bubble_out_primary"] = "color_bubble_out_primary";
    BubbleColorNames["color_bubble_in_primary"] = "color_bubble_in_primary";
    BubbleColorNames["color_bubble_out_secondary"] = "color_bubble_out_secondary";
    BubbleColorNames["color_bubble_in_secondary"] = "color_bubble_in_secondary";
    BubbleColorNames["color_bubble_out_third"] = "color_bubble_out_third";
    BubbleColorNames["color_bubble_in_third"] = "color_bubble_in_third";
    BubbleColorNames["color_bubble_out_fourth"] = "color_bubble_out_fourth";
    BubbleColorNames["color_bubble_in_fourth"] = "color_bubble_in_fourth";
    BubbleColorNames["color_bubble_low_text"] = "color_bubble_low_text";
    BubbleColorNames["color_bubble_receipt"] = "color_bubble_receipt";
    BubbleColorNames["color_bubble_progress"] = "color_bubble_progress";
    BubbleColorNames["color_bubble_seen_in_dark_bg"] = "color_bubble_seen_in_dark_bg";
})(BubbleColorNames || (BubbleColorNames = {}));
const BubbleColors = mapColorNameToCSSVariable(BubbleColorNames);
export var GradientColorNames;
(function (GradientColorNames) {
    GradientColorNames["color_gradient_magazine"] = "color_gradient_magazine";
    GradientColorNames["color_gradient_story_arbaein"] = "color_gradient_story_arbaein";
    GradientColorNames["color_gradient_story_world"] = "color_gradient_story_world";
    GradientColorNames["color_gradient_story_yalda"] = "color_gradient_story_yalda";
    GradientColorNames["color_gradient_story"] = "color_gradient_story";
    GradientColorNames["color_gradient_skeleton"] = "color_gradient_skeleton";
})(GradientColorNames || (GradientColorNames = {}));
const GradientColors = mapColorNameToCSSVariable(GradientColorNames);
export var FixedColorNames;
(function (FixedColorNames) {
    FixedColorNames["color_fixed_primary"] = "color_fixed_primary";
    FixedColorNames["color_fixed_neutrals_n_500"] = "color_fixed_neutrals_n_500";
    FixedColorNames["color_fixed_neutrals_n_400"] = "color_fixed_neutrals_n_400";
    FixedColorNames["color_fixed_neutrals_n_300"] = "color_fixed_neutrals_n_300";
    FixedColorNames["color_fixed_neutrals_n_200"] = "color_fixed_neutrals_n_200";
    FixedColorNames["color_fixed_neutrals_n_100"] = "color_fixed_neutrals_n_100";
    FixedColorNames["color_fixed_neutrals_n_50"] = "color_fixed_neutrals_n_50";
    FixedColorNames["color_fixed_neutrals_n_40"] = "color_fixed_neutrals_n_40";
    FixedColorNames["color_fixed_neutrals_n_30"] = "color_fixed_neutrals_n_30";
    FixedColorNames["color_fixed_neutrals_n_20"] = "color_fixed_neutrals_n_20";
    FixedColorNames["color_fixed_neutrals_n_10"] = "color_fixed_neutrals_n_10";
    FixedColorNames["color_fixed_neutrals_background"] = "color_fixed_neutrals_background";
    FixedColorNames["color_fixed_neutrals_surface"] = "color_fixed_neutrals_surface";
    FixedColorNames["color_fixed_neutrals_on_background"] = "color_fixed_neutrals_on_background";
    FixedColorNames["color_fixed_neutrals_high_brightness"] = "color_fixed_neutrals_high_brightness";
    FixedColorNames["color_fixed_neutrals_middle_brightness"] = "color_fixed_neutrals_middle_brightness";
    FixedColorNames["color_fixed_neutrals_low_brightness"] = "color_fixed_neutrals_low_brightness";
    FixedColorNames["color_fixed_error"] = "color_fixed_error";
    FixedColorNames["color_fixed_success"] = "color_fixed_success";
    FixedColorNames["color_fixed_link"] = "color_fixed_link";
    FixedColorNames["color_fixed_alert"] = "color_fixed_alert";
})(FixedColorNames || (FixedColorNames = {}));
const FixedColors = mapColorNameToCSSVariable(FixedColorNames);
export var RippleColorNames;
(function (RippleColorNames) {
    RippleColorNames["color_ripple"] = "color_ripple";
    RippleColorNames["color_primary_ripple"] = "color_primary_ripple";
    RippleColorNames["color_error_ripple"] = "color_error_ripple";
})(RippleColorNames || (RippleColorNames = {}));
const RippleColors = mapColorNameToCSSVariable(RippleColorNames);
export const ThemeColors = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, OldColors), PrimaryColors), DarkNeutralsColors), LightNeutralsColors), AlternativeColors), StateColors), BubbleColors), GradientColors), FixedColors), RippleColors);
//# sourceMappingURL=colorNames.js.map